import * as z from "zod";

export const addTeamToFeatureFlag = {
  name: "addTeamToFeatureFlag" as const,
  input: z.object({
    flagKey: z.string(),
    environmentKey: z.string().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
